export default {
    // 中
    zhCN: {
        filter_information: '筛选器信息',
        filter_name: '筛选器名称',
        user_name: '用户名',
        creation_time: '创建时间',
        splicing_description: '拼接描述',
        enable_or_not: '是否启用',
        association_symbol: '关联符号',
        screening_condition: '筛选条件',
        conditional_value: '条件值',
        not_included: '不包含',
        and: '并且',
        perhaps: '或者',
        not: '否',
        enable: '是',
        judgement_logic: '判断逻辑',
        please_add_judgment_logic: '请添加判断逻辑',
        model_platform_is: '车型平台：',
        subject_of_the_case_is: '案例主题：',
        overseas_branches_are: '分公司：',
        overseas_subsidiaries_are: '子公司：',
        general_agent_are: '总代：',
        fault_symptom_is: '故障现象：',
        cause_of_the_fault_is: '故障原因：',
        vehicle_status_is: '车辆状态：',
        case_type_is: '案例类型：',
        case_status_is: '案例状态：',
        dealer: '经销商：',
        dhl_account: 'DHL账号',
        address: '地址',
        consignee_company: '收货公司',
        return_rejection_reason: '回运拒绝原因',
        dhl_email: '待授权邮箱',
        is_return_executed: '是否执行回运',
    },
    // 英
    enUS: {
        filter_information: 'Filter information',
        filter_name: 'Filter name',
        user_name: 'User name',
        creation_time: 'Creation time',
        splicing_description: 'Splicing description',
        enable_or_not: 'Enabled or disabled',
        association_symbol: 'Relation symbol',
        screening_condition: 'Filtering condition',
        conditional_value: 'Filtering condition value',
        not_included: 'Not included',
        and: 'And',
        perhaps: 'Perhaps',
        not: 'Not',
        enable: 'Enable',
        judgement_logic: 'Judgement logic',
        relational_symbol: 'Relational symbol',
        filter_criteria: 'Filter criteria',
        please_add_judgment_logic: 'Please add judgment logic',
        model_platform_is: 'Platform：',
        subject_of_the_case_is: 'Case subject：',
        overseas_branches_are: 'Branch Company：',
        overseas_subsidiaries_are: 'Subsidiary Company：',
        general_agent_are: 'Distributor：',
        fault_symptom_is: 'Fault phenomenon：',
        cause_of_the_fault_is: 'Fault cause：',
        vehicle_status_is: 'Vehicle status：',
        case_type_is: 'Case type：',
        case_status_is: 'Case status：',
        dealer: 'Dealer：',
        dhl_account: 'DHL Account',
        address: 'Address',
        consignee_company: 'Consignee Company',
        return_rejection_reason: 'Reason for Return Rejection',
        dhl_email: 'Email Pending Auth',
        is_return_executed: 'Is Return Executed',
    },
    // 德
    deDE: {
        filter_information: 'Filterinformationen',
        filter_name: 'Filtername',
        user_name: 'Benutzername',
        creation_time: 'Erstellungszeit',
        splicing_description: 'Verbindungsbeschreibung',
        enable_or_not: 'Aktiviert oder deaktiviert',
        association_symbol: 'Beziehungssymbol',
        screening_condition: 'Filterbedingung',
        conditional_value: 'Filterbedingungswert',
        not_included: 'Nicht enthalten',
        and: 'Und',
        perhaps: 'Vielleicht',
        not: 'Nicht',
        enable: 'Aktiveren',
        judgement_logic: 'Beurteilungslogik',
        relational_symbol: 'Relationssymbol',
        filter_criteria: 'Filterkriterien',
        please_add_judgment_logic: 'Bitte Beurteilungslogik hinzufügen',
        model_platform_is: 'Fahrzeugplattform：',
        subject_of_the_case_is: 'Groß- und Kleinschreibung：',
        overseas_branches_are: 'Niederlassung：',
        overseas_subsidiaries_are: 'Tochtergesellschaft：',
        general_agent_are: 'Generalbevollmächtigter：',
        fault_symptom_is: 'Fehlerphänomen：',
        cause_of_the_fault_is: 'Fehlerursache：',
        vehicle_status_is: 'Fahrzeugstatus：',
        case_type_is: 'Fallart：',
        case_status_is: 'Fallstatus：',
        dealer: 'Händler：',
        dhl_account: 'DHL-Konto',
        address: 'Adresse',
        consignee_company: 'Empfängerfirma',
        return_rejection_reason: 'Grund für die Ablehnung der Rücksendung',
        dhl_email: 'E-Mail zur Freigabe',
        is_return_executed: 'Wurde die Rücksendung durchgeführt',
    },
    // 法
    frFR: {
        filter_information: 'Informations de filtre',
        filter_name: 'Nom du filtre',
        user_name: 'Nom d\'utilisateur',
        creation_time: 'Heure de création',
        splicing_description: 'Description',
        enable_or_not: 'Activé ou désactivé',
        association_symbol: 'Symbole de relation',
        screening_condition: 'Condition de filtrage',
        conditional_value: 'Valeur de la condition de filtrage ',
        not_included: 'Non inclus',
        and: 'Et',
        perhaps: 'Peut-être',
        not: 'Ne pas',
        enable: 'Activer',
        judgement_logic: 'Logique de jugement',
        relational_symbol: 'Symbole relationnel',
        filter_criteria: 'Critères de filtrage',
        please_add_judgment_logic: 'Veuillez ajouter une logique de jugement',
        model_platform_is: 'Plateforme：',
        subject_of_the_case_is: 'Sujet du cas：',
        overseas_branches_are: 'Succursale：',
        overseas_subsidiaries_are: 'Società controllata：',
        general_agent_are: 'Distributeur：',
        fault_symptom_is: 'Phénomène de défaillance：',
        cause_of_the_fault_is: 'Cause de la panne：',
        vehicle_status_is: 'Status du véhicule：',
        case_type_is: 'Type de cas：',
        case_status_is: 'Status du cas：',
        dealer: 'Distributeurs：',
        dhl_account: 'Compte DHL',
        address: 'Adresse',
        consignee_company: 'Société du destinataire',
        return_rejection_reason: 'Motif du refus de retour',
        dhl_email: 'Email en attente',
        is_return_executed: 'Le retour a-t-il été effectué',
    },
    // 意大利
    itIT: {
        filter_information: 'Informazioni sul filtro',
        filter_name: 'Nome del filtro',
        user_name: 'Username',
        creation_time: 'Data di creazione',
        splicing_description: 'Descrizione di giunzione',
        enable_or_not: 'Abilitato o disabilitato',
        association_symbol: 'Simbolo di associazione',
        screening_condition: 'Condizione di filtraggio',
        conditional_value: 'Valore di condizionamento di filtraggio',
        not_included: 'Non incluso',
        and: 'E',
        perhaps: 'Forse',
        not: 'Non',
        enable: 'Abilitare',
        judgement_logic: 'Logica di giudizio',
        relational_symbol: 'Simbolo relazionale',
        filter_criteria: 'Criteri di filtro',
        please_add_judgment_logic: 'Si prega di aggiungere la logica di giudizio',
        model_platform_is: 'Piattaforma del veicolo：',
        subject_of_the_case_is: 'Tema case：',
        overseas_branches_are: 'Filiale：',
        overseas_subsidiaries_are: 'Società controllata：',
        general_agent_are: 'Agente generale：',
        fault_symptom_is: 'Fenomeno di guasto：',
        cause_of_the_fault_is: 'Causa del guasto：',
        vehicle_status_is: 'Stato del veicolo：',
        case_type_is: 'Tipo di caso：',
        case_status_is: 'Stato del caso：',
        dealer: 'Rivenditore：',
        dhl_account: 'Account DHL',
        address: 'Indirizzo',
        consignee_company: 'Azienda del destinatario',
        return_rejection_reason: 'Motivo del rifiuto del reso',
        dhl_email: 'Email da autorizzare',
        is_return_executed: 'Il reso è stato eseguito',
    },
    // 荷兰
    nlNL: {
        filter_information: 'Filterinformatie',
        filter_name: 'Filternaam',
        user_name: 'Gebruikersnaam',
        creation_time: 'Creatietijd',
        splicing_description: 'Samenstellingsbeschrijving',
        enable_or_not: 'Inschakelen of niet',
        association_symbol: 'Verbonden symbool',
        screening_condition: 'Filtervoorwaarde',
        conditional_value: 'Filtervoorwaarde waarde',
        not_included: 'Niet inbegrepen',
        and: 'En',
        perhaps: 'Misschien',
        not: 'Niet',
        enable: 'Inschakelen',
        judgement_logic: 'Oordeelslogica',
        relational_symbol: 'Relatie symbool',
        filter_criteria: 'Filtercriteria',
        please_add_judgment_logic: 'Voeg alstublieft oordeelslogica toe',
        model_platform_is: 'Voertuigplatform：',
        subject_of_the_case_is: 'Hoofdthema：',
        overseas_branches_are: 'Vestiging：',
        overseas_subsidiaries_are: 'Dochteronderneming：',
        general_agent_are: 'Algemeen gemachtigde：',
        fault_symptom_is: 'Foutfenomeen：',
        cause_of_the_fault_is: 'Foutoorzaak：',
        vehicle_status_is: 'Voertuigstatus：',
        case_type_is: 'Zaaktype：',
        case_status_is: 'Zaakstatus：',
        dealer: 'Dealer：',
        dhl_account: 'DHL-account',
        address: 'Adres',
        consignee_company: 'Bedrijf van geadresseerde',
        return_rejection_reason: 'Reden voor weigering van retour',
        dhl_email: 'E-mail in afwachting',
        is_return_executed: 'Is retour uitgevoerd',
    },
    // 越南
    viVN: {
        filter_information: 'Thông tin bộ lọc',
        filter_name: 'Tên bộ lọc',
        user_name: 'Tên người dùng',
        creation_time: 'Thời gian tạo',
        splicing_description: 'Mô tả mối nối',
        enable_or_not: 'Đã kích hoạt hoặc vô hiệu hoá',
        association_symbol: 'Biểu tượng mối quan hệ',
        screening_condition: 'Điều kiện lọc',
        conditional_value: 'Giá trị điều kiện lọc',
        not_included: 'Không bao gồm',
        and: 'Và',
        perhaps: 'Hoặc',
        not: 'Không',
        enable: 'Bật',
        judgement_logic: 'Logic đánh giá',
        please_add_judgment_logic: 'Vui lòng thêm logic đánh giá',
        model_platform_is: 'Nền tảng：',
        subject_of_the_case_is: 'Chủ đề vụ việc：',
        overseas_branches_are: 'Công ty chi nhánh：',
        overseas_subsidiaries_are: 'Công ty con：',
        general_agent_are: 'Nhà phân phối：',
        fault_symptom_is: 'Hiện tượng lỗi：',
        cause_of_the_fault_is: 'Nguyên nhân lỗi：',
        vehicle_status_is: 'Tình trạng xe：',
        case_type_is: 'Loại vụ việc：',
        case_status_is: 'Trạng thái trường hợp：',
        dealer: 'Trang chủ：',
        dhl_account: 'Tài khoản DHL',
        address: 'Địa chỉ',
        consignee_company: 'Công ty nhận hàng',
        return_rejection_reason: 'Reden voor weigering van retour',
        dhl_email: 'Email chờ ủy quyền',
        is_return_executed: 'Is retour uitgevoerd',
    },
    // 西班牙
    esES: {
        filter_information: 'Información del filtro',
        filter_name: 'Nombre del filtro',
        user_name: 'Usuario',
        creation_time: 'Fecha de creación',
        splicing_description: 'Descripción concatenada',
        enable_or_not: 'Habilitado o Deshabilitado',
        association_symbol: 'Símbolo asociado',
        screening_condition: 'Condición de filtro',
        conditional_value: 'Valor de condición',
        not_included: 'No incluido',
        and: 'Y',
        perhaps: 'O',
        not: 'No',
        enable: 'Sí',
        judgement_logic: 'Lógica de evaluación',
        please_add_judgment_logic: 'Por favor, agregue lógica de evaluación',
        model_platform_is: 'Plataforma del modelo de vehículo：',
        subject_of_the_case_is: 'Tema del caso：',
        overseas_branches_are: 'Sucursal：',
        overseas_subsidiaries_are: 'Empresa subsidiaria：',
        general_agent_are: 'Distribuidor principal：',
        fault_symptom_is: 'Síntoma de falla：',
        cause_of_the_fault_is: 'Causa de falla：',
        vehicle_status_is: 'Estado del vehículo：',
        case_type_is: 'Tipo de caso：',
        case_status_is: 'Estado del caso：',
        dealer: 'Distribuidores：',
        dhl_account: 'Cuenta DHL',
        address: 'Dirección',
        consignee_company: 'Empresa del destinatario',
        return_rejection_reason: 'Motivo de rechazo del retorno',
        dhl_email: 'Email pendiente',
        is_return_executed: '¿Se realizó el retorno?',
    },
    // 葡萄牙
    ptBR: {
        filter_information: 'Informações do filtro',
        filter_name: 'Nome do filtro',
        user_name: 'Nome de usuário',
        creation_time: 'Tempo de criação',
        splicing_description: 'Descrição de junção',
        enable_or_not: 'Ativar ou não',
        association_symbol: 'Símbolo de associação',
        screening_condition: 'Condição de triagem',
        conditional_value: 'Valor condicional',
        not_included: 'Não incluído',
        and: 'E',
        perhaps: 'Ou',
        not: 'Não',
        enable: 'Sim',
        judgement_logic: 'Lógica de julgamento',
        please_add_judgment_logic: 'Por favor, adicione a lógica de julgamento',
        model_platform_is: 'Plataforma do modelo:',
        subject_of_the_case_is: 'Tema do caso:',
        overseas_branches_are: 'Filial:',
        overseas_subsidiaries_are: 'Subsidiária:',
        general_agent_are: 'Agente geral:',
        fault_symptom_is: 'Sintoma da falha:',
        cause_of_the_fault_is: 'Causa da falha:',
        vehicle_status_is: 'Status do veículo:',
        case_type_is: 'Tipo de caso:',
        case_status_is: 'Status do caso:',
        dealer: 'Revendedor:',
        dhl_account: 'Conta DHL',
        address: 'Endereço',
        consignee_company: 'Empresa do destinatário',
        return_rejection_reason: 'Motivo da recusa da devolução',
        dhl_email: 'Email pendente',
        is_return_executed: 'A devolução foi executada',
    },
    // 波兰
    plPL: {
        filter_information: 'Informacje o filtrze',
        filter_name: 'Nazwa filtra',
        user_name: 'Nazwa użytkownika',
        creation_time: 'Czas założenia',
        splicing_description: 'Opis połączenia',
        enable_or_not: 'Włączony czy wyłączony',
        association_symbol: 'Symbol relacji',
        screening_condition: 'Warunki filtrowania',
        conditional_value: 'Wartość warunku filtrowania',
        not_included: 'Nie zawiera',
        and: 'I',
        perhaps: 'Lub',
        not: 'Mie',
        enable: 'Włączony',
        judgement_logic: 'Logika oceny',
        please_add_judgment_logic: 'Proszę dodać logikę oceny',
        model_platform_is: 'Platforma pojazdu:',
        subject_of_the_case_is: 'Temat sprawy:',
        overseas_branches_are: 'Oddział:',
        overseas_subsidiaries_are: 'Spółka zależna:',
        general_agent_are: 'Dystrybutor:',
        fault_symptom_is: 'Zjawisko usterki:',
        cause_of_the_fault_is: 'Przyczyna usterki:',
        vehicle_status_is: 'Status pojazdu:',
        case_type_is: 'Typ sprawy:',
        case_status_is: 'Status sprawy:',
        dealer: 'Dealer:',
        dhl_account: 'Konto DHL',
        address: 'Adres',
        consignee_company: 'Firma odbiorcy',
        return_rejection_reason: 'Powód odrzucenia zwrotu',
        dhl_email: 'Email do autoryzacji',
        is_return_executed: 'Czy zwrot został wykonany',
    },
    // 土耳其
    trTR: {
        filter_information: 'Filtreleme bilgisi',
        filter_name: 'Filtreleme adı',
        user_name: 'Kullanıcı adı',
        creation_time: 'Oluşturma zamanı',
        splicing_description: 'Ayrılan tanımlama',
        enable_or_not: 'Etkinleştirildi ya da etkinleştirilmedi',
        association_symbol: 'İlişkisi sembolü',
        screening_condition: 'Filtreleme durumu',
        conditional_value: 'Filtreleme durum değeri',
        not_included: 'İçermiyor',
        and: 'Ve',
        perhaps: 'Belki de',
        not: 'Hayır.',
        enable: 'Etkinleştir',
        judgement_logic: 'Karar verme mantığı',
        please_add_judgment_logic: 'Lütfen karar verme mantığını ekleyin',
        model_platform_is: 'Platform：',
        subject_of_the_case_is: 'Dosya konusu：',
        overseas_branches_are: 'Şube şirketi：',
        overseas_subsidiaries_are: 'İştirak：',
        general_agent_are: 'Dağıtıcı：',
        fault_symptom_is: 'Arıza semptomu：',
        cause_of_the_fault_is: 'Hata sebebi：',
        vehicle_status_is: 'Araç durumu：',
        case_type_is: 'Dosya türü：',
        case_status_is: 'Dosya durumu：',
        dealer: 'distribütörler：',
        dhl_account: 'DHL Hesabı',
        address: 'Adres',
        consignee_company: 'Alıcı şirket',
        return_rejection_reason: 'İade red sebebi',
        dhl_email: 'Yetkilendirme bekleyen e-posta',
        is_return_executed: 'İade işlemi yapıldı mı',
    },
    // 捷克语
    csCZ: {
        filter_information: 'Filtrovat informace',
        filter_name: 'Název filtru',
        user_name: 'Uživatelské jméno',
        creation_time: 'Čas vytvoření',
        splicing_description: 'Splicing description',
        enable_or_not: 'Povoleno nebo zakázáno',
        association_symbol: 'Vztahový symbol',
        screening_condition: 'Podmínky filtrování',
        conditional_value: 'Hodnota podmínky filtrování',
        not_included: 'Nezahrnuje',
        and: 'A',
        perhaps: 'Možná',
        not: 'Ne',
        enable: 'Umožnit',
        judgement_logic: 'Logika posouzení',
        please_add_judgment_logic: 'Přidejte prosím logiku posouzení',
        model_platform_is: 'Platforma:',
        subject_of_the_case_is: 'Předmět případu:',
        overseas_branches_are: 'Pobočka:',
        overseas_subsidiaries_are: 'Dceřiná společnost:',
        general_agent_are: 'Distributor:',
        fault_symptom_is: 'Poruchový jev:',
        cause_of_the_fault_is: 'Příčina závady:',
        vehicle_status_is: 'Stav vozidla:',
        case_type_is: 'Typ případu:',
        case_status_is: 'Stav případu:',
        dealer: 'Dealer:',
        dhl_account: 'Účet DHL',
        address: 'Adresa',
        consignee_company: 'Společnost příjemce',
        return_rejection_reason: 'Důvod zamítnutí vrácení',
        dhl_email: 'E-mail k autorizaci',
        is_return_executed: 'Bylo vrácení provedeno',
    },
    // 匈牙利语
    huHU: {
        filter_information: 'Szűrőinformáció',
        filter_name: 'Szűrőnév',
        user_name: 'Felhasználónév',
        creation_time: 'Létrehozás ideje',
        splicing_description: 'Összeillesztési leírás',
        enable_or_not: 'Bekapcsolt vagy kikapcsolt',
        association_symbol: 'Relációs jel',
        screening_condition: 'Szűrési feltétel',
        conditional_value: 'Szűrési feltétel értéke',
        not_included: 'Nem része',
        and: 'És',
        perhaps: 'Talán',
        not: 'Nem',
        enable: 'Engedélyezés',
        judgement_logic: 'Elbírálási logika',
        please_add_judgment_logic: 'Adjon hozzá elbírálási logikát',
        model_platform_is: 'Platform:',
        subject_of_the_case_is: 'Eset tárgya:',
        overseas_branches_are: 'Fióktelep:',
        overseas_subsidiaries_are: 'Leányvállalat:',
        general_agent_are: 'Forgalmazó:',
        fault_symptom_is: 'Hibajelenség:',
        cause_of_the_fault_is: 'Hiba oka:',
        vehicle_status_is: 'Jármű állapota:',
        case_type_is: 'Eset típusa:',
        case_status_is: 'Eset állapota:',
        dealer: 'Kereskedő:',
        dhl_account: 'DHL fiók',
        address: 'Cím',
        consignee_company: 'Címzett cég',
        return_rejection_reason: 'Visszaküldés elutasításának oka',
        dhl_email: 'Felhatalmazásra váró e-mail',
        is_return_executed: 'Történt visszaküldés',
    },
    // 俄罗斯语
    ruRU: {
        filter_information: 'Информация о фильтре',
        filter_name: 'Название фильтра',
        user_name: 'Имя пользователя',
        creation_time: 'Время создания',
        splicing_description: 'Описание соединения',
        enable_or_not: 'Активирован или деактивирован',
        association_symbol: 'Символ связи',
        screening_condition: 'Условие фильтрации',
        conditional_value: 'Значение условия фильтрации',
        not_included: 'Не включается',
        and: 'И',
        perhaps: 'Или',
        not: 'Нет',
        enable: 'Активировать',
        judgement_logic: 'Логика проверки',
        please_add_judgment_logic: 'Добавьте логику проверки',
        model_platform_is: 'Платформа:',
        subject_of_the_case_is: 'Тема случая:',
        overseas_branches_are: 'Филиал:',
        overseas_subsidiaries_are: 'Дочерняя компания:',
        general_agent_are: 'Дистрибьютор:',
        fault_symptom_is: 'Симптом неисправности:',
        cause_of_the_fault_is: 'Причина неисправности:',
        vehicle_status_is: 'Состояние автомобиля:',
        case_type_is: 'Тип случая:',
        case_status_is: 'Статус случая:',
        dealer: 'Дилер:',
        dhl_account: 'Счет DHL',
        address: 'Адрес',
        consignee_company: 'Компания получателя',
        return_rejection_reason: 'Причина отказа возврата',
        dhl_email: 'Email ожидает авторизацию',
        is_return_executed: 'Выполнен ли возврат',
    },
    // 沙特阿拉伯
    arSA: {
        filter_information: 'معلومات المرشح',
        filter_name: 'اسم المرشح',
        user_name: 'اسم المستخدم',
        creation_time: 'وقت الإنشاء',
        splicing_description: 'وصف الربط',
        enable_or_not: 'هل تم التمكين؟',
        association_symbol: 'رمز الربط',
        screening_condition: 'شرط التصفية',
        conditional_value: 'قيمة الشرط',
        not_included: 'غير مشمول',
        and: 'و',
        perhaps: 'أو',
        not: 'لا',
        enable: 'نعم',
        judgement_logic: 'منطق الحكم',
        please_add_judgment_logic: 'يرجى إضافة منطق الحكم',
        model_platform_is: 'منصة الطراز:',
        subject_of_the_case_is: 'موضوع الحالة:',
        overseas_branches_are: 'الفروع الخارجية:',
        overseas_subsidiaries_are: 'الشركات التابعة الخارجية:',
        general_agent_are: 'الوكيل العام:',
        fault_symptom_is: 'أعراض العطل:',
        cause_of_the_fault_is: 'سبب العطل:',
        vehicle_status_is: 'حالة المركبة:',
        case_type_is: 'نوع الحالة:',
        case_status_is: 'حالة الحالة:',
        dealer: 'التاجر:',
        dhl_account: 'حساب DHL',
        address: 'العنوان',
        consignee_company: 'شركة المستلم',
        return_rejection_reason: 'سبب رفض الإرجاع',
        dhl_email: 'البريد الإلكتروني بانتظار التفويض',
        is_return_executed: 'هل تم تنفيذ الإرجاع؟',
    },
    // 保加利亚
    bgBG: {
        filter_information: 'Информация за филтъра',
        filter_name: 'Име на филтъра',
        user_name: 'Потребителско име',
        creation_time: 'Време на създаване',
        splicing_description: 'Описание на съединението',
        enable_or_not: 'Активирано ли е?',
        association_symbol: 'Символ за асоциация',
        screening_condition: 'Условие за филтриране',
        conditional_value: 'Стойност на условието',
        not_included: 'Не е включено',
        and: 'И',
        perhaps: 'Или',
        not: 'Не',
        enable: 'Да',
        judgement_logic: 'Логика на преценката',
        please_add_judgment_logic: 'Моля, добавете логика на преценката',
        model_platform_is: 'Платформа на модела:',
        subject_of_the_case_is: 'Тема на случая:',
        overseas_branches_are: 'Задгранични клонове:',
        overseas_subsidiaries_are: 'Задгранични дъщерни дружества:',
        general_agent_are: 'Главен агент:',
        fault_symptom_is: 'Симптом на неизправността:',
        cause_of_the_fault_is: 'Причина за неизправността:',
        vehicle_status_is: 'Състояние на превозното средство:',
        case_type_is: 'Тип на случая:',
        case_status_is: 'Статус на случая:',
        dealer: 'Дилър:',
        dhl_account: 'DHL акаунт',
        address: 'Адрес',
        consignee_company: 'Компания получател',
        return_rejection_reason: 'Причина за отказ на връщане',
        dhl_email: 'Имейл за одобрение',
        is_return_executed: 'Изпълнено ли е връщането?',
    },
    // 丹麦语
    daDK: {
        filter_information: 'Filterinformation',
        filter_name: 'Filternavn',
        user_name: 'Brugernavn',
        creation_time: 'Oprettelsestidspunkt',
        splicing_description: 'Samlingbeskrivelse',
        enable_or_not: 'Aktiveret eller ej',
        association_symbol: 'Tilknytningssymbol',
        screening_condition: 'Filtreringsbetingelse',
        conditional_value: 'Betingelsesværdi',
        not_included: 'Ikke inkluderet',
        and: 'Og',
        perhaps: 'Eller',
        not: 'Nej',
        enable: 'Ja',
        judgement_logic: 'Bedømmelseslogik',
        please_add_judgment_logic: 'Tilføj venligst bedømmelseslogik',
        model_platform_is: 'Modelplatform:',
        subject_of_the_case_is: 'Sagsemne:',
        overseas_branches_are: 'Udlandsafdelinger:',
        overseas_subsidiaries_are: 'Udlandsselskaber:',
        general_agent_are: 'Generel agent:',
        fault_symptom_is: 'Fejl symptom:',
        cause_of_the_fault_is: 'Fejlårsag:',
        vehicle_status_is: 'Køretøjstatus:',
        case_type_is: 'Sagstype:',
        case_status_is: 'Sagsstatus:',
        dealer: 'Forhandler:',
        dhl_account: 'DHL-konto',
        address: 'Adresse',
        consignee_company: 'Modtagerfirma',
        return_rejection_reason: 'Årsag til afvisning af retur',
        dhl_email: 'E-mail afventer godkendelse',
        is_return_executed: 'Er retur udført?',
    },
    // 芬兰语
    fiFI: {
        filter_information: 'Suodatin tiedot',
        filter_name: 'Suodattimen nimi',
        user_name: 'Käyttäjänimi',
        creation_time: 'Luontiaika',
        splicing_description: 'Liitoksen kuvaus',
        enable_or_not: 'Käytössä vai ei',
        association_symbol: 'Yhdistämisen symboli',
        screening_condition: 'Suodatusehto',
        conditional_value: 'Ehdon arvo',
        not_included: 'Ei sisälly',
        and: 'Ja',
        perhaps: 'Tai',
        not: 'Ei',
        enable: 'Kyllä',
        judgement_logic: 'Arviointilogiikka',
        please_add_judgment_logic: 'Lisää arviointilogiikka',
        model_platform_is: 'Mallialusta:',
        subject_of_the_case_is: 'Tapauksen aihe:',
        overseas_branches_are: 'Ulkomaan toimistot:',
        overseas_subsidiaries_are: 'Ulkomaan tytäryhtiöt:',
        general_agent_are: 'Pääasiamies:',
        fault_symptom_is: 'Vian oire:',
        cause_of_the_fault_is: 'Vian syy:',
        vehicle_status_is: 'Ajoneuvon tila:',
        case_type_is: 'Tapauksen tyyppi:',
        case_status_is: 'Tapauksen tila:',
        dealer: 'Jälleenmyyjä:',
        dhl_account: 'DHL-tili',
        address: 'Osoite',
        consignee_company: 'Vastaanottajayritys',
        return_rejection_reason: 'Palautuksen hylkäämisen syy',
        dhl_email: 'Sähköposti odottaa valtuutusta',
        is_return_executed: 'Onko palautus suoritettu?',
    },
    // 繁体中文台湾
    zhTW: {
        filter_information: '篩選器資訊',
        filter_name: '篩選器名稱',
        user_name: '使用者名稱',
        creation_time: '建立時間',
        splicing_description: '拼接描述',
        enable_or_not: '是否啟用',
        association_symbol: '關聯符號',
        screening_condition: '篩選條件',
        conditional_value: '條件值',
        not_included: '不包含',
        and: '並且',
        perhaps: '或者',
        not: '否',
        enable: '是',
        judgement_logic: '判斷邏輯',
        please_add_judgment_logic: '請新增判斷邏輯',
        model_platform_is: '車型平台：',
        subject_of_the_case_is: '案例主題：',
        overseas_branches_are: '分公司：',
        overseas_subsidiaries_are: '子公司：',
        general_agent_are: '總代：',
        fault_symptom_is: '故障現象：',
        cause_of_the_fault_is: '故障原因：',
        vehicle_status_is: '車輛狀態：',
        case_type_is: '案例類型：',
        case_status_is: '案例狀態：',
        dealer: '經銷商：',
        dhl_account: 'DHL帳號',
        address: '地址',
        consignee_company: '收貨公司',
        return_rejection_reason: '回運拒絕原因',
        dhl_email: '待授權電子信箱',
        is_return_executed: '是否執行回運',
    },
    // 克罗地亚
    hrHR: {
        filter_information: 'Informacije o filtru',
        filter_name: 'Naziv filtra',
        user_name: 'Korisničko ime',
        creation_time: 'Vrijeme stvaranja',
        splicing_description: 'Opis spajanja',
        enable_or_not: 'Omogućeno ili ne',
        association_symbol: 'Simbol povezivanja',
        screening_condition: 'Uvjet filtriranja',
        conditional_value: 'Vrijednost uvjeta',
        not_included: 'Nije uključeno',
        and: 'I',
        perhaps: 'Ili',
        not: 'Ne',
        enable: 'Da',
        judgement_logic: 'Logika prosuđivanja',
        please_add_judgment_logic: 'Dodajte logiku prosuđivanja',
        model_platform_is: 'Platforma modela:',
        subject_of_the_case_is: 'Tema slučaja:',
        overseas_branches_are: 'Inozemne podružnice:',
        overseas_subsidiaries_are: 'Inozemne kćerke:',
        general_agent_are: 'Glavni agent:',
        fault_symptom_is: 'Simptom kvara:',
        cause_of_the_fault_is: 'Uzrok kvara:',
        vehicle_status_is: 'Stanje vozila:',
        case_type_is: 'Vrsta slučaja:',
        case_status_is: 'Status slučaja:',
        dealer: 'Diler:',
        dhl_account: 'DHL račun',
        address: 'Adresa',
        consignee_company: 'Tvrtka primatelj',
        return_rejection_reason: 'Razlog odbijanja povrata',
        dhl_email: 'E-pošta čeka odobrenje',
        is_return_executed: 'Je li povrat izvršen?',
    },
    // 拉脱维亚
    lvLV: {
        filter_information: 'Filtra informācija',
        filter_name: 'Filtra nosaukums',
        user_name: 'Lietotājvārds',
        creation_time: 'Izveidošanas laiks',
        splicing_description: 'Savienojuma apraksts',
        enable_or_not: 'Vai ir aktivizēts?',
        association_symbol: 'Saistības simbols',
        screening_condition: 'Filtrēšanas nosacījums',
        conditional_value: 'Nosacījuma vērtība',
        not_included: 'Nav iekļauts',
        and: 'Un',
        perhaps: 'Vai',
        not: 'Nē',
        enable: 'Jā',
        judgement_logic: 'Loģiskais noteikums',
        please_add_judgment_logic: 'Lūdzu, pievienojiet loģisko noteikumu',
        model_platform_is: 'Modeļa platforma:',
        subject_of_the_case_is: 'Gadījuma tēma:',
        overseas_branches_are: 'Ārzemju filiāles:',
        overseas_subsidiaries_are: 'Ārzemju meitasuzņēmumi:',
        general_agent_are: 'Galvenais aģents:',
        fault_symptom_is: 'Kļūmes simptoms:',
        cause_of_the_fault_is: 'Kļūmes iemesls:',
        vehicle_status_is: 'Transportlīdzekļa statuss:',
        case_type_is: 'Gadījuma veids:',
        case_status_is: 'Gadījuma statuss:',
        dealer: 'Izplatītājs:',
        dhl_account: 'DHL konts',
        address: 'Adrese',
        consignee_company: 'Saņēmēja uzņēmums',
        return_rejection_reason: 'Atgriešanas noraidīšanas iemesls',
        dhl_email: 'E-pasts gaida autorizāciju',
        is_return_executed: 'Vai atgriešana ir izpildīta?',
    },
    // 立陶宛
    ltLT: {
        filter_information: 'Filtro informacija',
        filter_name: 'Filtro pavadinimas',
        user_name: 'Naudotojo vardas',
        creation_time: 'Sukūrimo laikas',
        splicing_description: 'Sujungimo aprašymas',
        enable_or_not: 'Ar įjungta?',
        association_symbol: 'Susiejimo simbolis',
        screening_condition: 'Filtravimo sąlyga',
        conditional_value: 'Sąlygos reikšmė',
        not_included: 'Neįtraukta',
        and: 'Ir',
        perhaps: 'Arba',
        not: 'Ne',
        enable: 'Taip',
        judgement_logic: 'Sprendimo logika',
        please_add_judgment_logic: 'Prašome pridėti sprendimo logiką',
        model_platform_is: 'Modelio platforma:',
        subject_of_the_case_is: 'Atvejo tema:',
        overseas_branches_are: 'Užsienio filialai:',
        overseas_subsidiaries_are: 'Užsienio dukterinės įmonės:',
        general_agent_are: 'Pagrindinis agentas:',
        fault_symptom_is: 'Gedimo simptomai:',
        cause_of_the_fault_is: 'Gedimo priežastis:',
        vehicle_status_is: 'Transporto priemonės būklė:',
        case_type_is: 'Atvejo tipas:',
        case_status_is: 'Atvejo būsena:',
        dealer: 'Platintojas:',
        dhl_account: 'DHL paskyra',
        address: 'Adresas',
        consignee_company: 'Gavėjo įmonė',
        return_rejection_reason: 'Grąžinimo atmetimo priežastis',
        dhl_email: 'El. paštas laukia patvirtinimo',
        is_return_executed: 'Ar grąžinimas įvykdytas?',
    },
    // 罗马尼亚
    roRO: {
        filter_information: 'Informații filtru',
        filter_name: 'Nume filtru',
        user_name: 'Nume utilizator',
        creation_time: 'Timp creare',
        splicing_description: 'Descriere îmbinare',
        enable_or_not: 'Activat sau nu',
        association_symbol: 'Simbol asociere',
        screening_condition: 'Condiție filtrare',
        conditional_value: 'Valoare condiție',
        not_included: 'Nu este inclus',
        and: 'Și',
        perhaps: 'Sau',
        not: 'Nu',
        enable: 'Da',
        judgement_logic: 'Logică judecată',
        please_add_judgment_logic: 'Vă rugăm să adăugați logică de judecată',
        model_platform_is: 'Platformă model:',
        subject_of_the_case_is: 'Subiect caz:',
        overseas_branches_are: 'Sucursale străine:',
        overseas_subsidiaries_are: 'Filiale străine:',
        general_agent_are: 'Agent general:',
        fault_symptom_is: 'Simptom defecțiune:',
        cause_of_the_fault_is: 'Cauză defecțiune:',
        vehicle_status_is: 'Stare vehicul:',
        case_type_is: 'Tip caz:',
        case_status_is: 'Stare caz:',
        dealer: 'Dealer:',
        dhl_account: 'Cont DHL',
        address: 'Adresă',
        consignee_company: 'Companie destinatar',
        return_rejection_reason: 'Motiv respingere returnare',
        dhl_email: 'Email în așteptarea autorizării',
        is_return_executed: 'Returnarea a fost executată?',
    },
    // 挪威博克马尔
    nbNO: {
        filter_information: 'Filterinformasjon',
        filter_name: 'Filternavn',
        user_name: 'Brukernavn',
        creation_time: 'Opprettelsestidspunkt',
        splicing_description: 'Beskrivelse av sammenføyning',
        enable_or_not: 'Aktivert eller ikke',
        association_symbol: 'Assosiasjonssymbol',
        screening_condition: 'Filterbetingelse',
        conditional_value: 'Betingelsesverdi',
        not_included: 'Ikke inkludert',
        and: 'Og',
        perhaps: 'Eller',
        not: 'Nei',
        enable: 'Ja',
        judgement_logic: 'Dommerlogikk',
        please_add_judgment_logic: 'Vennligst legg til dommerlogikk',
        model_platform_is: 'Modellplattform:',
        subject_of_the_case_is: 'Sakstema:',
        overseas_branches_are: 'Utenlandsavdelinger:',
        overseas_subsidiaries_are: 'Utenlandsselskaper:',
        general_agent_are: 'Hovedagent:',
        fault_symptom_is: 'Feilsymptom:',
        cause_of_the_fault_is: 'Feilårsak:',
        vehicle_status_is: 'Kjøretøystatus:',
        case_type_is: 'Sakstype:',
        case_status_is: 'Saksstatus:',
        dealer: 'Forhandler:',
        dhl_account: 'DHL-konto',
        address: 'Adresse',
        consignee_company: 'Mottakerbedrift',
        return_rejection_reason: 'Årsak til avvisning av retur',
        dhl_email: 'E-post venter på godkjenning',
        is_return_executed: 'Er retur utført?',
    },
    // 葡萄牙语巴西
    ptBX: {
        filter_information: 'Informações do filtro',
        filter_name: 'Nome do filtro',
        user_name: 'Nome de usuário',
        creation_time: 'Hora de criação',
        splicing_description: 'Descrição da junção',
        enable_or_not: 'Habilitado ou não',
        association_symbol: 'Símbolo de associação',
        screening_condition: 'Condição de filtragem',
        conditional_value: 'Valor da condição',
        not_included: 'Não incluído',
        and: 'E',
        perhaps: 'Ou',
        not: 'Não',
        enable: 'Sim',
        judgement_logic: 'Lógica de julgamento',
        please_add_judgment_logic: 'Por favor, adicione a lógica de julgamento',
        model_platform_is: 'Plataforma do modelo:',
        subject_of_the_case_is: 'Assunto do caso:',
        overseas_branches_are: 'Filiais no exterior:',
        overseas_subsidiaries_are: 'Empresas subsidiárias no exterior:',
        general_agent_are: 'Agente geral:',
        fault_symptom_is: 'Sintoma da falha:',
        cause_of_the_fault_is: 'Causa da falha:',
        vehicle_status_is: 'Estado do veículo:',
        case_type_is: 'Tipo de caso:',
        case_status_is: 'Status do caso:',
        dealer: 'Concessionária:',
        dhl_account: 'Conta DHL',
        address: 'Endereço',
        consignee_company: 'Empresa destinatária',
        return_rejection_reason: 'Motivo da recusa de devolução',
        dhl_email: 'E-mail aguardando autorização',
        is_return_executed: 'A devolução foi executada?',
    },
    // 瑞典语
    svSE: {
        filter_information: 'Filterinformation',
        filter_name: 'Filternamn',
        user_name: 'Användarnamn',
        creation_time: 'Skapandetid',
        splicing_description: 'Beskrivning av sammanfogning',
        enable_or_not: 'Aktiverad eller inte',
        association_symbol: 'Associeringssymbol',
        screening_condition: 'Filtreringsvillkor',
        conditional_value: 'Villkorsvärde',
        not_included: 'Inte inkluderat',
        and: 'Och',
        perhaps: 'Eller',
        not: 'Nej',
        enable: 'Ja',
        judgement_logic: 'Bedömningslogik',
        please_add_judgment_logic: 'Lägg till bedömningslogik',
        model_platform_is: 'Modellplattform:',
        subject_of_the_case_is: 'Ämne för ärendet:',
        overseas_branches_are: 'Utrikesfilialer:',
        overseas_subsidiaries_are: 'Utrikesdotterbolag:',
        general_agent_are: 'Huvudagent:',
        fault_symptom_is: 'Felsymtom:',
        cause_of_the_fault_is: 'Orsak till felet:',
        vehicle_status_is: 'Fordonsstatus:',
        case_type_is: 'Ärendetyp:',
        case_status_is: 'Ärendestatus:',
        dealer: 'Återförsäljare:',
        dhl_account: 'DHL-konto',
        address: 'Adress',
        consignee_company: 'Mottagarföretag',
        return_rejection_reason: 'Anledning till returvärjande',
        dhl_email: 'E-post väntar på godkännande',
        is_return_executed: 'Har returen genomförts?',
    },
    // 斯洛伐克
    skSK: {
        filter_information: 'Informácie o filtri',
        filter_name: 'Názov filtra',
        user_name: 'Používateľské meno',
        creation_time: 'Čas vytvorenia',
        splicing_description: 'Popis spojenia',
        enable_or_not: 'Povolené alebo nie',
        association_symbol: 'Asociačný symbol',
        screening_condition: 'Podmienka filtrovania',
        conditional_value: 'Hodnota podmienky',
        not_included: 'Nie je zahrnuté',
        and: 'A',
        perhaps: 'Alebo',
        not: 'Nie',
        enable: 'Áno',
        judgement_logic: 'Logika rozhodovania',
        please_add_judgment_logic: 'Pridajte logiku rozhodovania',
        model_platform_is: 'Platforma modelu:',
        subject_of_the_case_is: 'Predmet prípadu:',
        overseas_branches_are: 'Zahraničné pobočky:',
        overseas_subsidiaries_are: 'Zahraničné dcérske spoločnosti:',
        general_agent_are: 'Hlavný agent:',
        fault_symptom_is: 'Príznak poruchy:',
        cause_of_the_fault_is: 'Príčina poruchy:',
        vehicle_status_is: 'Stav vozidla:',
        case_type_is: 'Typ prípadu:',
        case_status_is: 'Stav prípadu:',
        dealer: 'Predajca:',
        dhl_account: 'DHL účet',
        address: 'Adresa',
        consignee_company: 'Spoločnosť príjemcu',
        return_rejection_reason: 'Dôvod zamietnutia vrátenia',
        dhl_email: 'E-mail čaká na autorizáciu',
        is_return_executed: 'Bolo vrátenie vykonané?',
    },
    // 斯洛文尼亚
    slSI: {
        filter_information: 'Informacije o filtru',
        filter_name: 'Ime filtra',
        user_name: 'Uporabniško ime',
        creation_time: 'Čas ustvarjanja',
        splicing_description: 'Opis združevanja',
        enable_or_not: 'Omogočeno ali ne',
        association_symbol: 'Simbol povezave',
        screening_condition: 'Pogoj za filtriranje',
        conditional_value: 'Vrednost pogoja',
        not_included: 'Ni vključeno',
        and: 'In',
        perhaps: 'Ali',
        not: 'Ne',
        enable: 'Da',
        judgement_logic: 'Logika presoje',
        please_add_judgment_logic: 'Prosimo, dodajte logiko presoje',
        model_platform_is: 'Platforma modela:',
        subject_of_the_case_is: 'Tema primera:',
        overseas_branches_are: 'Tujinske podružnice:',
        overseas_subsidiaries_are: 'Tujinske hčerinske družbe:',
        general_agent_are: 'Glavni zastopnik:',
        fault_symptom_is: 'Simptom okvare:',
        cause_of_the_fault_is: 'Vzrok okvare:',
        vehicle_status_is: 'Stanje vozila:',
        case_type_is: 'Vrsta primera:',
        case_status_is: 'Status primera:',
        dealer: 'Prodajalec:',
        dhl_account: 'DHL račun',
        address: 'Naslov',
        consignee_company: 'Prejemniško podjetje',
        return_rejection_reason: 'Razlog za zavrnitev vračila',
        dhl_email: 'E-naslov čaka na pooblastilo',
        is_return_executed: 'Ali je vračilo izvedeno?',
    },
    // 泰语
    thTH: {
        filter_information: 'ข้อมูลตัวกรอง',
        filter_name: 'ชื่อตัวกรอง',
        user_name: 'ชื่อผู้ใช้',
        creation_time: 'เวลาสร้าง',
        splicing_description: 'คำอธิบายการเชื่อมต่อ',
        enable_or_not: 'เปิดใช้งานหรือไม่',
        association_symbol: 'สัญลักษณ์เชื่อมโยง',
        screening_condition: 'เงื่อนไขการคัดกรอง',
        conditional_value: 'ค่าเงื่อนไข',
        not_included: 'ไม่รวม',
        and: 'และ',
        perhaps: 'หรือ',
        not: 'ไม่',
        enable: 'ใช่',
        judgement_logic: 'ตรรกะการตัดสินใจ',
        please_add_judgment_logic: 'กรุณาเพิ่มตรรกะการตัดสินใจ',
        model_platform_is: 'แพลตฟอร์มรุ่น:',
        subject_of_the_case_is: 'หัวข้อกรณี:',
        overseas_branches_are: 'สาขาต่างประเทศ:',
        overseas_subsidiaries_are: 'บริษัทในเครือต่างประเทศ:',
        general_agent_are: 'ตัวแทนทั่วไป:',
        fault_symptom_is: 'อาการขัดข้อง:',
        cause_of_the_fault_is: 'สาเหตุของความขัดข้อง:',
        vehicle_status_is: 'สถานะรถ:',
        case_type_is: 'ประเภทกรณี:',
        case_status_is: 'สถานะกรณี:',
        dealer: 'ผู้จัดจำหน่าย:',
        dhl_account: 'บัญชี DHL',
        address: 'ที่อยู่',
        consignee_company: 'บริษัทผู้รับสินค้า',
        return_rejection_reason: 'เหตุผลปฏิเสธการส่งคืน',
        dhl_email: 'อีเมลรอการอนุมัติ',
        is_return_executed: 'ดำเนินการส่งคืนหรือไม่',
    },
    // 乌克兰语
    ukUA: {
        filter_information: 'Інформація про фільтр',
        filter_name: 'Назва фільтра',
        user_name: 'Ім’я користувача',
        creation_time: 'Час створення',
        splicing_description: 'Опис з’єднання',
        enable_or_not: 'Чи увімкнено',
        association_symbol: 'Символ зв’язку',
        screening_condition: 'Умова фільтрації',
        conditional_value: 'Значення умови',
        not_included: 'Не включено',
        and: 'І',
        perhaps: 'Або',
        not: 'Ні',
        enable: 'Так',
        judgement_logic: 'Логіка судження',
        please_add_judgment_logic: 'Будь ласка, додайте логіку судження',
        model_platform_is: 'Платформа моделі:',
        subject_of_the_case_is: 'Тема випадку:',
        overseas_branches_are: 'Закордонні філії:',
        overseas_subsidiaries_are: 'Закордонні дочірні компанії:',
        general_agent_are: 'Генеральний агент:',
        fault_symptom_is: 'Симптом несправності:',
        cause_of_the_fault_is: 'Причина несправності:',
        vehicle_status_is: 'Стан автомобіля:',
        case_type_is: 'Тип випадку:',
        case_status_is: 'Статус випадку:',
        dealer: 'Дилер:',
        dhl_account: 'Обліковий запис DHL',
        address: 'Адреса',
        consignee_company: 'Компанія-одержувач',
        return_rejection_reason: 'Причина відмови у поверненні',
        dhl_email: 'Електронна пошта очікує авторизації',
        is_return_executed: 'Чи виконано повернення?',
    },
    // 希腊语
    elGR: {
        filter_information: 'Πληροφορίες φίλτρου',
        filter_name: 'Όνομα φίλτρου',
        user_name: 'Όνομα χρήστη',
        creation_time: 'Ώρα δημιουργίας',
        splicing_description: 'Περιγραφή σύνδεσης',
        enable_or_not: 'Ενεργοποιημένο ή όχι',
        association_symbol: 'Σύμβολο συσχέτισης',
        screening_condition: 'Συνθήκη φιλτραρίσματος',
        conditional_value: 'Τιμή συνθήκης',
        not_included: 'Δεν περιλαμβάνεται',
        and: 'Και',
        perhaps: 'Ή',
        not: 'Όχι',
        enable: 'Ναι',
        judgement_logic: 'Λογική κρίσης',
        please_add_judgment_logic: 'Παρακαλούμε προσθέστε λογική κρίσης',
        model_platform_is: 'Πλατφόρμα μοντέλου:',
        subject_of_the_case_is: 'Θέμα της υπόθεσης:',
        overseas_branches_are: 'Υποκαταστήματα εξωτερικού:',
        overseas_subsidiaries_are: 'Θυγατρικές εταιρείες εξωτερικού:',
        general_agent_are: 'Γενικός αντιπρόσωπος:',
        fault_symptom_is: 'Σύμπτωμα βλάβης:',
        cause_of_the_fault_is: 'Αιτία βλάβης:',
        vehicle_status_is: 'Κατάσταση οχήματος:',
        case_type_is: 'Τύπος υπόθεσης:',
        case_status_is: 'Κατάσταση υπόθεσης:',
        dealer: 'Έμπορος:',
        dhl_account: 'Λογαριασμός DHL',
        address: 'Διεύθυνση',
        consignee_company: 'Εταιρεία παραλήπτης',
        return_rejection_reason: 'Αιτία απόρριψης επιστροφής',
        dhl_email: 'Ηλεκτρονικό ταχυδρομείο αναμονής εξουσιοδότησης',
        is_return_executed: 'Έχει εκτελεστεί η επιστροφή;',
    },
    // 爱沙尼亚
    etEE: {
        filter_information: 'Filtri teave',
        filter_name: 'Filtri nimi',
        user_name: 'Kasutajanimi',
        creation_time: 'Loomise aeg',
        splicing_description: 'Ühenduse kirjeldus',
        enable_or_not: 'Kas lubatud?',
        association_symbol: 'Seose sümbol',
        screening_condition: 'Filtreerimistingimus',
        conditional_value: 'Tingimuse väärtus',
        not_included: 'Pole kaasatud',
        and: 'Ja',
        perhaps: 'Või',
        not: 'Ei',
        enable: 'Jah',
        judgement_logic: 'Otsustusloogika',
        please_add_judgment_logic: 'Palun lisa otsustusloogika',
        model_platform_is: 'Mudeli platvorm:',
        subject_of_the_case_is: 'Juhtumi teema:',
        overseas_branches_are: 'Välisfiliaalid:',
        overseas_subsidiaries_are: 'Välismaa tütarettevõtted:',
        general_agent_are: 'Peaagent:',
        fault_symptom_is: 'Vea sümptom:',
        cause_of_the_fault_is: 'Vea põhjus:',
        vehicle_status_is: 'Sõiduki seisund:',
        case_type_is: 'Juhtumi tüüp:',
        case_status_is: 'Juhtumi olek:',
        dealer: 'Edasimüüja:',
        dhl_account: 'DHL konto',
        address: 'Aadress',
        consignee_company: 'Saaja ettevõte',
        return_rejection_reason: 'Tagastuse tagasilükkamise põhjus',
        dhl_email: 'Meil ootab volitust',
        is_return_executed: 'Kas tagastus on sooritatud?',
    },
    // 哈萨克
    kkKZ: {
        filter_information: 'Фильтр туралы ақпарат',
        filter_name: 'Фильтр атауы',
        user_name: 'Пайдаланушы аты',
        creation_time: 'Жасалған уақыты',
        splicing_description: 'Қосылыс сипаттамасы',
        enable_or_not: 'Қосулы ма, жоқ па',
        association_symbol: 'Байланыс белгісі',
        screening_condition: 'Сүзгілеу шарты',
        conditional_value: 'Шарт мәні',
        not_included: 'Қамтылмаған',
        and: 'Және',
        perhaps: 'Немесе',
        not: 'Жоқ',
        enable: 'Иә',
        judgement_logic: 'Шешім қабылдау логикасы',
        please_add_judgment_logic: 'Шешім қабылдау логикасын қосыңыз',
        model_platform_is: 'Автокөлік платформасы:',
        subject_of_the_case_is: 'Жағдайдың тақырыбы:',
        overseas_branches_are: 'Шетелдегі бөлімшелер:',
        overseas_subsidiaries_are: 'Шетелдегі қызметкер компаниялар:',
        general_agent_are: 'Басты агент:',
        fault_symptom_is: 'Ақау белгілері:',
        cause_of_the_fault_is: 'Ақау себебі:',
        vehicle_status_is: 'Көлік күйі:',
        case_type_is: 'Жағдай түрі:',
        case_status_is: 'Жағдай күйі:',
        dealer: 'Дилер:',
        dhl_account: 'DHL тіркелгісі',
        address: 'Мекенжай',
        consignee_company: 'Алушы компания',
        return_rejection_reason: 'Қайтарудан бас тарту себебі',
        dhl_email: 'Авторизацияны күтетін электрондық пошта',
        is_return_executed: 'Қайтару орындалды ма?',
    },
    // 希伯来语
    heIL: {
        filter_information: 'מידע על המסנן',
        filter_name: 'שם המסנן',
        user_name: 'שם משתמש',
        creation_time: 'זמן יצירה',
        splicing_description: 'תיאור שרשור',
        enable_or_not: 'האם מופעל?',
        association_symbol: 'סמל קישור',
        screening_condition: 'תנאי סינון',
        conditional_value: 'ערך תנאי',
        not_included: 'לא כלול',
        and: 'וגם',
        perhaps: 'או',
        not: 'לא',
        enable: 'כן',
        judgement_logic: 'לוגיקת שיפוט',
        please_add_judgment_logic: 'אנא הוסף לוגיקת שיפוט',
        model_platform_is: 'פלטפורמת דגם:',
        subject_of_the_case_is: 'נושא המקרה:',
        overseas_branches_are: 'סניפים בחו"ל:',
        overseas_subsidiaries_are: 'חברות בת בחו"ל:',
        general_agent_are: 'סוכן ראשי:',
        fault_symptom_is: 'תסמיני תקלה:',
        cause_of_the_fault_is: 'סיבת התקלה:',
        vehicle_status_is: 'מצב הרכב:',
        case_type_is: 'סוג המקרה:',
        case_status_is: 'סטטוס המקרה:',
        dealer: 'סוכנות:',
        dhl_account: 'חשבון DHL',
        address: 'כתובת',
        consignee_company: 'חברת הנמען',
        return_rejection_reason: 'סיבת דחיית החזרה',
        dhl_email: 'דוא"ל בהמתנה לאישור',
        is_return_executed: 'האם בוצעה החזרה?',
    },
};
